import { render, staticRenderFns } from "./DiscountChangeDialog.vue?vue&type=template&id=650cda8b&scoped=true&"
import script from "./DiscountChangeDialog.vue?vue&type=script&lang=js&"
export * from "./DiscountChangeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cda8b",
  null
  
)

export default component.exports